import React, { useContext } from 'react';
import styles from './HouseRegisterCheck.module.scss';
import { Checkbox } from 'antd';
import { ReactComponent as HomeAddres } from '../../../../../resource/HomeAddres.svg';
import { getStreetName } from '../../../utils/getStreetName';
import { declensions } from '../../../constants/declensions';
import { generateExpWithNum } from '../../../utils/generateExpWithNum';
import TypeIcon from '../HouseRegistrationTypeManager/components/TypeIcon/TypeIcon';
import {
  HandleItemChangeContext,
  SelectedItemsContext,
} from '../../../pages/ChangingAllPage/Provider';

const HouseRegisterCheck = ({ house }) => {
  const handleItemChange = useContext(HandleItemChangeContext);
  const selectedItems = useContext(SelectedItemsContext);

  const flatText = house.flatCount
    ? generateExpWithNum(house.flatCount, declensions.flats)
    : '';

  return (
    <div className={styles.conteiner}>
      <div className={styles.block}>
        <HomeAddres />
        <div>
          <div style={{ display: 'flex', gap: '5px' }}>
            <div className={styles.houseNumber}>
              {house?.corpus
                ? `№${house.building} к${house.corpus}`
                : `№${house.building}`}
            </div>
            <div className={styles.streetName}>{`(${getStreetName(
              house.streetName
            )})`}</div>
          </div>
          <div className={styles.flatCount}>{flatText}</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <TypeIcon type={house?.registrationType} />
        <Checkbox
          className={styles.customCheckboxReg}
          checked={
            !!selectedItems?.find(
              (selected) => selected.houseId === house.houseId
            )
          }
          onChange={() => handleItemChange(house)}
        />
      </div>
    </div>
  );
};

export default HouseRegisterCheck;
